import React from "react";
import PropTypes from "prop-types";
import { DragSource, DropTarget } from "react-dnd";

import { withStyles } from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";
import Divider from "@material-ui/core/Divider";

import validateRule from "../../../services/ruleValidator.service";

import { itemSource, itemTarget } from "../../../helpers/dndSimple.helper";
import { Switch, Input, InputBase } from "@material-ui/core";
import { updateRuleText } from "../../../store/actions/rule.actions.js";
import { addMessage } from "../../../store/actions/message.actions.js";
import { connect } from "react-redux";

const styles = theme => ({
  row: {
    width: "100%",
    height: "44px",
    padding: "6px 0px"
  },
  dragIcon: {
    float: "left",
    marginRight: "4px",
    cursor: "move",
    color: theme.palette.grey[500]
  },

  deleteIcon: {
    float: "right",
    cursor: "pointer",
    color: theme.palette.grey[500],
    marginLeft: '20px',
    "&:hover": {
      color: theme.palette.red
    }
  },
  editIcon: {
    cursor: "pointer",
    color: theme.palette.grey[500],
    marginLeft: "12px",
    float: 'right'
  },
  saveIcon: {
    cursor: "pointer",
    color: theme.palette.grey[500],
    marginLeft: "12px",
    float: 'right'
  },
  text: {
    float: "left"
  },
  divider: {
    clear: "both",
    content: " "
  },
  switch: {
    marginTop: "-10px",
    marginRight: "10px",
    float: "right"
  }
});

class AppliedRulesDetailComponent extends React.Component {
  constructor(props) {
    super(props);

    this.handleDelete = this.handleDelete.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleChangeActiveRule = this.handleChangeActiveRule.bind(this);
    this.onChangeAppliedRule = this.onChangeAppliedRule.bind(this);
    this.state = {
      active: false,
      isBeingEdited: false,
      rule: this.props.rule
    };
  }
  componentDidMount() {
    if (this.props.rule.active === undefined) {
      this.props.rule.active = true;
      this.handleChangeActiveRule(undefined, true);
    }
    this.setState({ active: this.props.rule.active });
  }
  handleDelete() {
    this.props.deleteRule(this.props.rule.id);
  }
  handleEdit() {
    this.setState({
      isBeingEdited: true
    });
  }
  handleSave() {
    if (validateRule(this.state.rule.text)) {
      this.props.updateRuleText(this.props.rule.id, this.state.rule.text);
      this.setState({
        isBeingEdited: false
      });
      this.props.addMessage("success", "Updated rule");
    } else {
      this.props.addMessage("error", "Rule not recognized");
    }
  }
  onChangeAppliedRule(event) {
    this.setState({
      rule: {
        ...this.state.rule,
        text: event.target.value
      }
    });
  }

  handleChangeActiveRule(event, checked) {
    this.setState({ active: checked });
    this.props.updateRuleActive(this.props.rule.id, checked);
  }
  render() {
    const {
      connectDragSource,
      connectDropTarget,
      connectDragPreview,
      isDragging,
      classes
    } = this.props;
    return (
      connectDragPreview &&
      connectDragSource &&
      connectDropTarget &&
      connectDropTarget(
        connectDragPreview(
          <div style={{ opacity: isDragging ? 0 : 1 }} className={classes.row}>
            {connectDragSource(
              <span>
                <Icon className={classes.dragIcon}>drag_indicator</Icon>
              </span>
            )}

            {this.state.isBeingEdited ? (
              <React.Fragment>
                <Input
                  className={classes.text}
                  onChange={this.onChangeAppliedRule}
                  value={this.state.rule.text}
                  style={{width:'70%'}}

                />
              </React.Fragment>
            ) : (
              <React.Fragment>
                <InputBase
                  readOnly
                  value={this.state.rule.text}
                  className={classes.text}
                  style={{width:'70%'}}
                />
              </React.Fragment>
            )}

            <Icon onClick={this.handleDelete} className={classes.deleteIcon}>
              delete
            </Icon>
            {this.state.isBeingEdited ? (
              <Icon onClick={this.handleSave} className={classes.saveIcon}>
                save
              </Icon>
            ) : (
              <Icon onClick={this.handleEdit} className={classes.editIcon}>
                edit
              </Icon>
            )}
            <Switch
              disabled={!this.props.rulesApplied}
              onChange={this.handleChangeActiveRule}
              checked={this.state.active}
              className={classes.switch}
            />

            <Divider className={classes.divider} />
          </div>
        )
      )
    );
  }
}

AppliedRulesDetailComponent.propTypes = {
  rule: PropTypes.shape({
    id: PropTypes.number,
    text: PropTypes.string,
    attribute: PropTypes.string,
    active: PropTypes.bool
  }).isRequired,
  connectDragSource: PropTypes.func.isRequired,
  connectDropTarget: PropTypes.func.isRequired,
  connectDragPreview: PropTypes.func.isRequired,
  isDragging: PropTypes.bool.isRequired,
  /* eslint-disable react/forbid-prop-types, react/no-unused-prop-types */
  index: PropTypes.number.isRequired,
  moveRule: PropTypes.func.isRequired,
  dropRule: PropTypes.func.isRequired,
  deleteRule: PropTypes.func.isRequired,
  updateRuleActive: PropTypes.func.isRequired,
  updateRuleText: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  rulesApplied: PropTypes.bool

  /* eslint-enable */
};

export default connect(
  null,
  { updateRuleText, addMessage }
)(
  DropTarget("rule", itemTarget, connect => ({
    connectDropTarget: connect.dropTarget()
  }))(
    DragSource("rule", itemSource, (connect, monitor) => ({
      connectDragSource: connect.dragSource(),
      connectDragPreview: connect.dragPreview(),
      isDragging: monitor.isDragging()
    }))(withStyles(styles)(AppliedRulesDetailComponent))
  )
);
